module.exports = __webpack_public_path__ + "static/Felis-D2-05790c8167f75a66be6c7c098a2d6031.webp";